import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UI_ROUTES } from '../app.contant';
import { IRFQTemplateDetail, INegotiationCreateRequest } from '../modules/pr-buyer/models';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from '../modules/admin/services/admin.service';
import { SupplierService } from '../modules/supplier/services/supplier.service';
import { EncryptionService } from '../modules/dashboard/services/encryption.service';

@Component({
  selector: 'app-unregistered-vendor-negotiation',
  templateUrl: './unregistered-vendor-negotiation.component.html',
  styleUrls: ['./unregistered-vendor-negotiation.component.scss']
})
export class UnregisteredVendorNegotiationComponent implements OnInit {

  public rfqTemplate !: any;
  public negotiationRequest !: any;
  public negotiationForm !: FormGroup;
  public templateId:any;
  public supplier_id:any;
  public negotiationPayload : any = [];

  // Route variables
  public readonly ROUTES = UI_ROUTES;
  public paymentTermsList: any;

  constructor(
    private _supplierService : SupplierService,
    private _fb : FormBuilder,
    private _router: Router,
    private _activatedRoute : ActivatedRoute,
    private _adminService: AdminService,
    private _toastr : ToastrService,
    private _encryptionServie: EncryptionService,
  ) { }

  ngOnInit(): void {
    this._activatedRoute.queryParams?.subscribe((val: any) => {
      this.templateId = val.id;
      this.supplier_id = val.supplierId;
      console.log("templateId:", this.templateId, this.supplier_id)
      this._supplierService.getNegotiationForUnRegisteredVendor(this.templateId, this.supplier_id).subscribe((res: any) => {
        if (res.status == 200) {
          console.log("res.data", res.data)
          this.rfqTemplate = res.data;
          this.negotiationRequest = {
            "prId": this.rfqTemplate[0].prId.prId,
            "buyer_id": this.rfqTemplate[0].buyer_id.id,
            "rfq_template_id": this.rfqTemplate[0].rfq_template_id.id
          }
          this.rfqTemplate && this.prepareNegotiationForm();
        }
      })
    })

    this._adminService.getPaymentTermKey().subscribe((res: any) => {
      if (res.status = 200) {
        this.paymentTermsList = res.data
      }
    });
  }

  private prepareNegotiationForm(rfqTemplate: any = this.rfqTemplate): void {
    const formArr = this._fb.array([]);
    if (rfqTemplate?.length) {
      rfqTemplate.forEach((y: any) => {
        // if(y.isNegotationDone){
        const formGroup = this._fb.group({
          id: [y.id, Validators.required],
          final_price: [y.final_price, [Validators.required, Validators.pattern(/^\d+(\.\d+)?$/)]],
          buyer_counter_offer: [y.buyer_counter_offer, Validators.required],
          supplier_remarks: [y.supplier_remarks],
          buyer_remarks: [y.buyer_remarks],
          negotiation_status: [y.negotiation_status, Validators.required],
          negotiation_count: [y.negotiation_count],
          line_item: [y.line_item_number, Validators.required],
          un_reg_vendor: [y.un_reg_vendor?.id, Validators.required],
          packing_percent_or_amount: y?.packing_percent_or_amount,
          packing_charge: y?.packing_charge,
          final_packing_charge: y?.final_packing_charge,
          freight_percent_or_amount: y?.freight_percent_or_amount,
          freight_charge: y?.freight_charge,
          final_freight_charge: y?.final_freight_charge,
          original_price: y?.original_price,
          final_payment_terms: y?.final_payment_terms,
          original_payment_terms: y?.original_payment_terms
        });
        formArr.push(formGroup);
        // }
      })
      console.log("formArr", formArr)
      this.negotiationForm = this._fb.group({
        negotiations: formArr
      });
    }
  }

  get customFormArrayControls(): any {
    const formArr = this.negotiationForm.controls['negotiations'] as FormGroup;
    return formArr.controls
  }

  public sendConsolidatedNegotiationDetails(): void {
    console.log(this.negotiationForm);
    const negotiationFormValue = this.negotiationForm.value;
    negotiationFormValue.negotiations.forEach((x: any) => {
      const line_item_number = x.line_item;
      const { line_item, ...data } = x;
      data.line_item_number = line_item_number;
      this.negotiationPayload.push({...this.negotiationRequest,...data})
    });
    console.log(this.negotiationPayload);
    this._supplierService.updateNegotiation(this.negotiationPayload).subscribe((res: any) => {
      console.log(res);
      if (res.status == 200) {
        this._toastr.success("Negotiation Sent to buyer");
        this._router.navigateByUrl(this.ROUTES.SUPPLIER.HOME)
      }
    });
  }

}
